// Authentications
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';

export const PASSWORD_EXPIRED = 'PASSWORD_EXPIRED';
export const CHANGE_PASSWORD_SUCCESS_TEMP = 'CHANGE_PASSWORD_SUCCESS_TEMP';
export const CHANGE_PASSWORD_REQUEST_TEMP = 'CHANGE_PASSWORD_REQUEST_TEMP';
export const CHANGE_PASSWORD_FAILURE_TEMP = 'CHANGE_PASSWORD_FAILURE_TEMP';
export const CONFIRM_PASSWORD_EXPIRED = 'CONFIRM_PASSWORD_EXPIRED'; // New action



// Alert Message
export const FETCH_ALERT_REQUEST = 'FETCH_ALERT_REQUEST';
export const FETCH_ALERT_SUCCESS = 'FETCH_ALERT_SUCCESS';
export const FETCH_ALERT_FAILURE = 'FETCH_ALERT_FAILURE';


// User Profile
export const FETCH_PROFILE_REQUEST = 'FETCH_PROFILE_REQUEST';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
export const RESET_CHANGE_PASSWORD_SUCCESS = 'RESET_CHANGE_PASSWORD_SUCCESS';

export const UPDATE_TENANT_DETAILS_REQUEST = 'UPDATE_TENANT_DETAILS_REQUEST';
export const UPDATE_TENANT_DETAILS_SUCCESS = 'UPDATE_TENANT_DETAILS_SUCCESS';
export const UPDATE_TENANT_DETAILS_FAILURE = 'UPDATE_TENANT_DETAILS_FAILURE';
export const RESET_TENANT_DETAILS_SUCCESS = 'RESET_TENANT_DETAILS_SUCCESS';

// Homepage content
export const FETCH_NARRATIVES_REQUEST = 'FETCH_NARRATIVES_REQUEST';
export const FETCH_NARRATIVES_SUCCESS = 'FETCH_NARRATIVES_SUCCESS';
export const FETCH_NARRATIVES_FAILURE = 'FETCH_NARRATIVES_FAILURE';

// What's new
export const FETCH_NEW_CONTENT_REQUEST = 'FETCH_NEW_CONTENT_REQUEST';
export const FETCH_NEW_CONTENT_SUCCESS = 'FETCH_NEW_CONTENT_SUCCESS';
export const FETCH_NEW_CONTENT_FAILURE = 'FETCH_NEW_CONTENT_FAILURE';


// FAQ
export const FETCH_FAQ_REQUEST = 'FETCH_FAQ_REQUEST';
export const FETCH_FAQ_SUCCESS = 'FETCH_FAQ_SUCCESS';
export const FETCH_FAQ_FAILURE = 'FETCH_FAQ_FAILURE';


// Demo Catakgue
export const FETCH_DEMO_CATALOG_REQUEST = 'FETCH_DEMO_CATALOG_REQUEST';
export const FETCH_DEMO_CATALOG_SUCCESS = 'FETCH_DEMO_CATALOG_SUCCESS';
export const FETCH_DEMO_CATALOG_FAILURE = 'FETCH_DEMO_CATALOG_FAILURE';

export const FETCH_NARRATIVE_DETAILS_REQUEST = 'FETCH_NARRATIVE_DETAILS_REQUEST';
export const FETCH_NARRATIVE_DETAILS_SUCCESS = 'FETCH_NARRATIVE_DETAILS_SUCCESS';
export const FETCH_NARRATIVE_DETAILS_FAILURE = 'FETCH_NARRATIVE_DETAILS_FAILURE';


// Reset Demo Page Content
export const FETCH_RESET_OPERATIONS_REQUEST = 'FETCH_RESET_OPERATIONS_REQUEST';
export const FETCH_RESET_OPERATIONS_SUCCESS = 'FETCH_RESET_OPERATIONS_SUCCESS';
export const FETCH_RESET_OPERATIONS_FAILURE = 'FETCH_RESET_OPERATIONS_FAILURE';


// Content Store 
export const FETCH_CONTENT_REQUEST = 'FETCH_CONTENT_REQUEST';
export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS';
export const FETCH_CONTENT_FAILURE = 'FETCH_CONTENT_FAILURE';


// Ingestion
export const POST_DATA_REQUEST = 'POST_DATA_REQUEST'
export const POST_DATA_SUCCESS = 'POST_DATA_SUCCESS'
export const POST_DATA_FAILURE = 'POST_DATA_FAILURE'
export const POST_DATA_RESET = 'POST_DATA_RESET'


export const RESET_REQUEST = 'RESET_REQUEST';
export const RESET_SUCCESS = 'RESET_SUCCESS';
export const RESET_FAILURE = 'RESET_FAILURE';
export const RESET_ON_SUCCESS = 'RESET_ON_SUCCESS';

// Learning Hub
export const FETCH_LEARNING_HUB_REQUEST = 'FETCH_LEARNING_HUB_REQUEST';
export const FETCH_LEARNING_HUB_SUCCESS = 'FETCH_LEARNING_HUB_SUCCESS';
export const FETCH_LEARNING_HUB_FAILURE = 'FETCH_LEARNING_HUB_FAILURE';

// To take microcert details
export const FETCH_LEARNING_HUB_DETAILS_REQUEST = 'FETCH_LEARNING_HUB_DETAILS_REQUEST';
export const FETCH_LEARNING_HUB_DETAILS_SUCCESS = 'FETCH_LEARNING_HUB_DETAILS_SUCCESS';
export const FETCH_LEARNING_HUB_DETAILS_FAILURE = 'FETCH_LEARNING_HUB_DETAILS_FAILURE';


export const SET_TEMPORARY_COMPLETION_BADGE = 'SET_TEMPORARY_COMPLETION_BADGE';


export const UPDATE_VIDEO_STATUS_REQUEST = 'UPDATE_VIDEO_STATUS_REQUEST';
export const UPDATE_VIDEO_STATUS_SUCCESS = 'UPDATE_VIDEO_STATUS_SUCCESS';
export const UPDATE_VIDEO_STATUS_FAILURE = 'UPDATE_VIDEO_STATUS_FAILURE';
export const RESET_UPDATE_VIDEO_STATUS_SUCCESS = 'RESET_UPDATE_VIDEO_STATUS_SUCCESS';


export const VALIDATE_QUIZ_REQUEST = 'VALIDATE_QUIZ_REQUEST';
export const VALIDATE_QUIZ_SUCCESS = 'VALIDATE_QUIZ_SUCCESS';
export const VALIDATE_QUIZ_FAILURE = 'VALIDATE_QUIZ_FAILURE';
export const RESET_QUIZ_RESULT = 'RESET_QUIZ_RESULT';





// Tenent Booking
export const FETCH_BOOKINGS_REQUEST = 'FETCH_BOOKINGS_REQUEST';
export const FETCH_BOOKINGS_SUCCESS = 'FETCH_BOOKINGS_SUCCESS';
export const FETCH_BOOKINGS_FAILURE = 'FETCH_BOOKINGS_FAILURE';


// Book Tenent 
export const BOOK_TENANT_REQUEST = 'BOOK_TENANT_REQUEST';
export const BOOK_TENANT_SUCCESS = 'BOOK_TENANT_SUCCESS';
export const BOOK_TENANT_FAILURE = 'BOOK_TENANT_FAILURE';
export const RESE_BOOK_TENANT_SUCCESS = 'RESE_BOOK_TENANT_SUCCESS';

// Release Tenent
export const RELEASE_TENANT_REQUEST = 'RELEASE_TENANT_REQUEST';
export const RELEASE_TENANT_SUCCESS = 'RELEASE_TENANT_SUCCESS';
export const RELEASE_TENANT_FAILURE = 'RELEASE_TENANT_FAILURE';
export const RESE_RELEASE_TENANT_SUCCESS = 'RESET_RELEASE_TENANT_SUCCESS';



// Generic Search 
export const GENERIC_SEARCH_REQUEST = 'GENERIC_SEARCH_REQUEST';
export const GENERIC_SEARCH_SUCCESS = 'GENERIC_SEARCH_SUCCESS';
export const GENERIC_SEARCH_FAILURE = 'GENERIC_SEARCH_FAILURE';

// Narrative Search
export const NARRATIVE_SEARCH_REQUEST = 'NARRATIVE_SEARCH_REQUEST';
export const NARRATIVE_SEARCH_SUCCESS = 'NARRATIVE_SEARCH_SUCCESS';
export const NARRATIVE_SEARCH_FAILURE = 'NARRATIVE_SEARCH_FAILURE';


// faq Search
export const FAQ_SEARCH_REQUEST = 'FAQ_SEARCH_REQUEST';
export const FAQ_SEARCH_SUCCESS = 'FAQ_SEARCH_SUCCESS';
export const FAQ_SEARCH_FAILURE = 'FAQ_SEARCH_FAILURE';


// Content Store Searcj
export const CONTENT_SEARCH_REQUEST = 'CONTENT_SEARCH_REQUEST';
export const CONTENT_SEARCH_SUCCESS = 'CONTENT_SEARCH_SUCCESS';
export const CONTENT_SEARCH_FAILURE = 'CONTENT_SEARCH_FAILURE';



// SE Analytics
export const FETCH_SE_ANALYTIC_REQUEST = 'FETCH_SE_ANALYTIC_REQUEST';
export const FETCH_SE_ANALYTIC_SUCCESS = 'FETCH_SE_ANALYTIC_SUCCESS';
export const FETCH_SE_ANALYTIC_FAILURE = 'FETCH_SE_ANALYTIC_FAILURE';
// Manger Analytics
export const FETCH_MANAGER_ANALYTIC_REQUEST = 'FETCH_MANAGER_ANALYTIC_REQUEST';
export const FETCH_MANAGER_ANALYTIC_SUCCESS = 'FETCH_MANAGER_ANALYTIC_SUCCESS';
export const FETCH_MANAGER_ANALYTIC_FAILURE = 'FETCH_MANAGER_ANALYTIC_FAILURE';
// Leadership Analytics
export const FETCH_LEADERSHIP_ANALYTIC_REQUEST = 'FETCH_LEADERSHIP_ANALYTIC_REQUEST';
export const FETCH_LEADERSHIP_ANALYTIC_SUCCESS = 'FETCH_LEADERSHIP_ANALYTIC_SUCCESS';
export const FETCH_LEADERSHIP_ANALYTIC_FAILURE = 'FETCH_LEADERSHIP_ANALYTIC_FAILURE';




// Sales Personas Homepage
export const FETCH_SALES_PERSONAS_REQUEST = 'FETCH_PERSONAS_SALES_REQUEST';
export const FETCH_SALES_PERSONAS_SUCCESS = 'FETCH_PERSONAS_SALES_SUCCESS';
export const FETCH_SALES_PERSONAS_FAILURE = 'FETCH_PERSONAS_SALES_FAILURE';

// Fetch Existing Demo Session
export const FETCH_EXISTING_DEMO_SESSION_REQUEST = 'FETCH_EXISTING_DEMO_SESSION_REQUEST';
export const FETCH_EXISTING_DEMO_SESSION_SUCCESS = 'FETCH_EXISTING_DEMO_SESSION_SUCCESS';
export const FETCH_EXISTING_DEMO_SESSION_FAILURE = 'FETCH_EXISTING_DEMO_SESSION_FAILURE';
export const CLEAR_EXISTING_DEMO_SESSION = 'CLEAR_EXISTING_DEMO_SESSION,';



// Create Customer Demo & Practise & Get Page Details
export const CREATE_SALES_DEMO_CUST_OR_PRACT_REQUEST = 'CREATE_SALES_DEMO_CUST_OR_PRACT_REQUEST';
export const CREATE_SALES_DEMO_CUST_OR_PRACT_SUCCESS = 'CREATE_SALES_DEMO_CUST_OR_PRACT_SUCCESS';
export const CREATE_SALES_DEMO_CUST_OR_PRACT_FAILURE = 'CREATE_SALES_DEMO_CUST_OR_PRACT_FAILURE';
export const CLEAR_CREATE_SALES_DEMO_CUST_OR_PRACT = 'CLEAR_CREATE_SALES_DEMO_CUST_OR_PRACT,';



// Delete Customer Demo & Practise
export const DELETE_CUSTOMER_DEMO_REQUEST = 'DELETE_CUSTOMER_DEMO_REQUEST';
export const DELETE_CUSTOMER_DEMO_SUCCESS = 'DELETE_CUSTOMER_DEMO_SUCCESS';
export const DELETE_CUSTOMER_DEMO_FAILURE = 'DELETE_CUSTOMER_DEMO_FAILURE';



export const UPDATE_CUSTOMER_DEMO_REQUEST = 'UPDATE_CUSTOMER_DEMO_REQUEST';
export const UPDATE_CUSTOMER_DEMO_SUCCESS = 'UPDATE_CUSTOMER_DEMO_SUCCESS';
export const UPDATE_CUSTOMER_DEMO_FAILURE = 'UPDATE_CUSTOMER_DEMO_FAILURE';



// Get Partner Discliamer
export const GET_PARTNER_DISCLAIMER_REQUEST = 'GET_PARTNER_DISCLAIMER_REQUEST';
export const GET_PARTNER_DISCLAIMER_SUCCESS = 'GET_PARTNER_DISCLAIMER_SUCCESS';
export const GET_PARTNER_DISCLAIMER_FAILURE = 'GET_PARTNER_DISCLAIMER_FAILURE';






// Update Disclaimer Status
export const UPDATE_DISCLAIMER_STATUS_REQUEST = 'UPDATE_DISCLAIMER_STATUS_REQUEST';
export const UPDATE_DISCLAIMER_STATUS_SUCCESS = 'UPDATE_DISCLAIMER_STATUS_SUCCESS';
export const UPDATE_DISCLAIMER_STATUS_FAILURE = 'UPDATE_DISCLAIMER_STATUS_FAILURE';


// Get Sales Walkthough
export const FETCH_SALES_WALKTHROUGH_REQUEST = "FETCH_SALES_WALKTHROUGH_REQUEST";
export const FETCH_SALES_WALKTHROUGH_SUCCESS = "FETCH_SALES_WALKTHROUGH_SUCCESS";
export const FETCH_SALES_WALKTHROUGH_FAILURE = "FETCH_SALES_WALKTHROUGH_FAILURE";


export const UPDATE_SALES_WALKTHROUGH_REQUEST = "UPDATE_SALES_WALKTHROUGH_REQUEST";
export const UPDATE_SALES_WALKTHROUGH_SUCCESS = "UPDATE_SALES_WALKTHROUGH_SUCCESS";
export const UPDATE_SALES_WALKTHROUGH_FAILURE = "UPDATE_SALES_WALKTHROUGH_FAILURE";



// Get Analytics Filter
export const GET_ANALYTICS_FILTERS_REQUEST = 'GET_ANALYTICS_FILTERS_REQUEST';
export const GET_ANALYTICS_FILTERS_SUCCESS = 'GET_ANALYTICS_FILTERS_SUCCESS';
export const GET_ANALYTICS_FILTERS_FAILURE = 'GET_ANALYTICS_FILTERS_FAILURE';



export const FETCH_GET_UPGRADE_REQUEST = "FETCH_GET_UPGRADE_REQUEST";
export const FETCH_GET_UPGRADE_SUCCESS = "FETCH_GET_UPGRADE_SUCCESS";
export const FETCH_GET_UPGRADE_FAILURE = "FETCH_GET_UPGRADE_FAILURE";



// Post Upgrade Action Types
export const POST_UPGRADE_REQUEST = 'POST_UPGRADE_REQUEST';
export const POST_UPGRADE_SUCCESS = 'POST_UPGRADE_SUCCESS';
export const POST_UPGRADE_FAILURE = 'POST_UPGRADE_FAILURE';
export const RESET_UPGRADE_STATE = 'RESET_UPGRADE_STATE';



// Yads
export const FETCH_YADS_TENANT_SCENARIOS_REQUEST = "FETCH_YADS_TENANT_SCENARIOS_REQUEST";
export const FETCH_YADS_TENANT_SCENARIOS_SUCCESS = "FETCH_YADS_TENANT_SCENARIOS_SUCCESS";
export const FETCH_YADS_TENANT_SCENARIOS_FAILURE = "FETCH_YADS_TENANT_SCENARIOS_FAILURE";

export const FETCH_YADS_STATUS_REQUEST = "FETCH_YADS_STATUS_REQUEST";
export const FETCH_YADS_STATUS_SUCCESS = "FETCH_YADS_STATUS_SUCCESS";
export const FETCH_YADS_STATUS_FAILURE = "FETCH_YADS_STATUS_FAILURE";

export const POST_YADS_INGESTION_REQUEST = "POST_YADS_INGESTION_REQUEST";
export const POST_YADS_INGESTION_SUCCESS = "POST_YADS_INGESTION_SUCCESS";
export const POST_YADS_INGESTION_FAILURE = "POST_YADS_INGESTION_FAILURE";
// actionTypes.js
export const POST_YADS_INGESTION_RESET = 'POST_YADS_INGESTION_RESET';

// actionTypes.js
export const POST_YADS_SCHEDULE_REQUEST = "POST_YADS_SCHEDULE_REQUEST";
export const POST_YADS_SCHEDULE_SUCCESS = "POST_YADS_SCHEDULE_SUCCESS";
export const POST_YADS_SCHEDULE_FAILURE = "POST_YADS_SCHEDULE_FAILURE";
export const POST_YADS_SCHEDULE_RESET   = "POST_YADS_SCHEDULE_RESET";


// actionTypes.js
export const DELETE_YADS_SCHEDULE_REQUEST = "DELETE_YADS_SCHEDULE_REQUEST";
export const DELETE_YADS_SCHEDULE_SUCCESS = "DELETE_YADS_SCHEDULE_SUCCESS";
export const DELETE_YADS_SCHEDULE_FAILURE = "DELETE_YADS_SCHEDULE_FAILURE";
export const DELETE_YADS_SCHEDULE_RESET   = "DELETE_YADS_SCHEDULE_RESET";


// actionTypes.js
export const PATCH_YADS_TENANT_REQUEST = 'PATCH_YADS_TENANT_REQUEST';
export const PATCH_YADS_TENANT_SUCCESS = 'PATCH_YADS_TENANT_SUCCESS';
export const PATCH_YADS_TENANT_FAILURE = 'PATCH_YADS_TENANT_FAILURE';
export const PATCH_YADS_TENANT_RESET   = 'PATCH_YADS_TENANT_RESET';

export const RESCHEDULE_YADS_REQUEST   = 'RESCHEDULE_YADS_REQUEST';
export const RESCHEDULE_YADS_SUCCESS   = 'RESCHEDULE_YADS_SUCCESS';
export const RESCHEDULE_YADS_FAILURE   = 'RESCHEDULE_YADS_FAILURE';
export const RESCHEDULE_YADS_RESET     = 'RESCHEDULE_YADS_RESET';



// Recurring Scheduling
export const POST_YADS_RECURRING_REQUEST = "POST_YADS_RECURRING_REQUEST";
export const POST_YADS_RECURRING_SUCCESS = "POST_YADS_RECURRING_SUCCESS";
export const POST_YADS_RECURRING_FAILURE = "POST_YADS_RECURRING_FAILURE";
export const POST_YADS_RECURRING_RESET   = "POST_YADS_RECURRING_RESET";






// dELETE Recurring Scheduling
export const DELETE_YADS_RECURRING_SCHEDULE_REQUEST = "DELETE_YADS_RECURRING_SCHEDULE_REQUEST";
export const DELETE_YADS_RECURRING_SCHEDULE_SUCCESS = "DELETE_YADS_RECURRING_SCHEDULE_SUCCESS";
export const DELETE_YADS_RECURRING_SCHEDULE_FAILURE = "DELETE_YADS_RECURRING_SCHEDULE_FAILURE";
export const DELETE_YADS_RECURRING_SCHEDULE_RESET   = "DELETE_YADS_RECURRING_SCHEDULE_RESET";





// Onboard tenant 
export const ONBOARD_TENANT_REQUEST = 'ONBOARD_TENANT_REQUEST';
export const ONBOARD_TENANT_SUCCESS = 'ONBOARD_TENANT_SUCCESS';
export const ONBOARD_TENANT_FAILURE = 'ONBOARD_TENANT_FAILURE';
export const RESET_ONBOARD_TENANT_SUCCESS = 'RESET_ONBOARD_TENANT_SUCCESS';



// PATCH Recurring Scheduling (Edit)
export const PATCH_YADS_RECURRING_SCHEDULE_REQUEST = "PATCH_YADS_RECURRING_SCHEDULE_REQUEST";
export const PATCH_YADS_RECURRING_SCHEDULE_SUCCESS = "PATCH_YADS_RECURRING_SCHEDULE_SUCCESS";
export const PATCH_YADS_RECURRING_SCHEDULE_FAILURE = "PATCH_YADS_RECURRING_SCHEDULE_FAILURE";
export const PATCH_YADS_RECURRING_SCHEDULE_RESET   = "PATCH_YADS_RECURRING_SCHEDULE_RESET";



// Forgot password
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';
export const FORGOT_PASSWORD_RESET   = 'FORGOT_PASSWORD_RESET';


// src/Redux/Constants/actionTypes.js
export const CHANGE_PASSWORD_BY_URL_REQUEST = 'CHANGE_PASSWORD_BY_URL_REQUEST';
export const CHANGE_PASSWORD_BY_URL_SUCCESS = 'CHANGE_PASSWORD_BY_URL_SUCCESS';
export const CHANGE_PASSWORD_BY_URL_FAILURE = 'CHANGE_PASSWORD_BY_URL_FAILURE';
export const CHANGE_PASSWORD_BY_URL_RESET   = 'CHANGE_PASSWORD_BY_URL_RESET';


// ✅ NEW: PATCH user tenant details
export const PATCH_USER_TENANT_REQUEST = "PATCH_USER_TENANT_REQUEST";
export const PATCH_USER_TENANT_SUCCESS = "PATCH_USER_TENANT_SUCCESS";
export const PATCH_USER_TENANT_FAILURE = "PATCH_USER_TENANT_FAILURE";
export const PATCH_USER_TENANT_RESET   = "PATCH_USER_TENANT_RESET";



// ✅ NEW: cancel running ingestion
export const CANCEL_INGESTION_REQUEST = "CANCEL_INGESTION_REQUEST";
export const CANCEL_INGESTION_SUCCESS = "CANCEL_INGESTION_SUCCESS";
export const CANCEL_INGESTION_FAILURE = "CANCEL_INGESTION_FAILURE";
export const CANCEL_INGESTION_RESET   = "CANCEL_INGESTION_RESET";


// actionTypes.js
export const DELETE_USER_TENANT_REQUEST = "DELETE_USER_TENANT_REQUEST";
export const DELETE_USER_TENANT_SUCCESS = "DELETE_USER_TENANT_SUCCESS";
export const DELETE_USER_TENANT_FAILURE = "DELETE_USER_TENANT_FAILURE";
export const DELETE_USER_TENANT_RESET   = "DELETE_USER_TENANT_RESET";


// Admin Users
export const FETCH_USER_MODULE_DETAILS_REQUEST = "FETCH_USER_MODULE_DETAILS_REQUEST";
export const FETCH_USER_MODULE_DETAILS_SUCCESS = "FETCH_USER_MODULE_DETAILS_SUCCESS";
export const FETCH_USER_MODULE_DETAILS_FAILURE = "FETCH_USER_MODULE_DETAILS_FAILURE";

export const UPDATE_PENDING_REQUEST_REQUEST = "UPDATE_PENDING_REQUEST_REQUEST";
export const UPDATE_PENDING_REQUEST_SUCCESS = "UPDATE_PENDING_REQUEST_SUCCESS";
export const UPDATE_PENDING_REQUEST_FAILURE = "UPDATE_PENDING_REQUEST_FAILURE";

export const APPROVE_PENDING_REQUEST_REQUEST = "APPROVE_PENDING_REQUEST_REQUEST";
export const APPROVE_PENDING_REQUEST_SUCCESS = "APPROVE_PENDING_REQUEST_SUCCESS";
export const APPROVE_PENDING_REQUEST_FAILURE = "APPROVE_PENDING_REQUEST_FAILURE";

export const REJECT_PENDING_REQUEST_REQUEST = "REJECT_PENDING_REQUEST_REQUEST";
export const REJECT_PENDING_REQUEST_SUCCESS = "REJECT_PENDING_REQUEST_SUCCESS";
export const REJECT_PENDING_REQUEST_FAILURE = "REJECT_PENDING_REQUEST_FAILURE";

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const CREATE_ACCOUNT_REQUEST = "CREATE_ACCOUNT_REQUEST";
export const CREATE_ACCOUNT_SUCCESS = "CREATE_ACCOUNT_SUCCESS";
export const CREATE_ACCOUNT_FAILURE = "CREATE_ACCOUNT_FAILURE";

export const CREATE_ADMIN_ACCOUNT_REQUEST = "CREATE_ADMIN_ACCOUNT_REQUEST";
export const CREATE_ADMIN_ACCOUNT_SUCCESS = "CREATE_ADMIN_ACCOUNT_SUCCESS";
export const CREATE_ADMIN_ACCOUNT_FAILURE = "CREATE_ADMIN_ACCOUNT_FAILURE";

export const RESET_ADMIN_USER_PASSWORD_REQUEST = "RESET_ADMIN_USER_PASSWORD_REQUEST";
export const RESET_ADMIN_USER_PASSWORD_SUCCESS = "RESET_ADMIN_USER_PASSWORD_SUCCESS";
export const RESET_ADMIN_USER_PASSWORD_FAILURE = "RESET_ADMIN_USER_PASSWORD_FAILURE";

export const FETCH_ACCOUNT_TYPE_MAPPING_REQUEST = "FETCH_ACCOUNT_TYPE_MAPPING_REQUEST";
export const FETCH_ACCOUNT_TYPE_MAPPING_SUCCESS = "FETCH_ACCOUNT_TYPE_MAPPING_SUCCESS";
export const FETCH_ACCOUNT_TYPE_MAPPING_FAILURE = "FETCH_ACCOUNT_TYPE_MAPPING_FAILURE";

export const FETCH_PENDING_REQUEST_COUNT_REQUEST = "FETCH_PENDING_REQUEST_COUNT_REQUEST";
export const FETCH_PENDING_REQUEST_COUNT_SUCCESS = "FETCH_PENDING_REQUEST_COUNT_SUCCESS";
export const FETCH_PENDING_REQUEST_COUNT_FAILURE = "FETCH_PENDING_REQUEST_COUNT_FAILURE";

// Admin Shared Tenants
export const FETCH_ADMIN_SHARED_TENANTS_REQUEST = "FETCH_ADMIN_SHARED_TENANTS_REQUEST";
export const FETCH_ADMIN_SHARED_TENANTS_SUCCESS = "FETCH_ADMIN_SHARED_TENANTS_SUCCESS";
export const FETCH_ADMIN_SHARED_TENANTS_FAILURE = "FETCH_ADMIN_SHARED_TENANTS_FAILURE";

export const FETCH_ADMIN_SHARED_TENANT_DETAIL_REQUEST = "FETCH_ADMIN_SHARED_TENANT_DETAIL_REQUEST";
export const FETCH_ADMIN_SHARED_TENANT_DETAIL_SUCCESS = "FETCH_ADMIN_SHARED_TENANT_DETAIL_SUCCESS";
export const FETCH_ADMIN_SHARED_TENANT_DETAIL_FAILURE = "FETCH_ADMIN_SHARED_TENANT_DETAIL_FAILURE";
export const CLEAR_ADMIN_SHARED_TENANT_DETAIL = "CLEAR_ADMIN_SHARED_TENANT_DETAIL";

export const UPDATE_ADMIN_SHARED_TENANT_STATUS_REQUEST = "UPDATE_ADMIN_SHARED_TENANT_STATUS_REQUEST";
export const UPDATE_ADMIN_SHARED_TENANT_STATUS_SUCCESS = "UPDATE_ADMIN_SHARED_TENANT_STATUS_SUCCESS";
export const UPDATE_ADMIN_SHARED_TENANT_STATUS_FAILURE = "UPDATE_ADMIN_SHARED_TENANT_STATUS_FAILURE";

export const UPDATE_ADMIN_BOOKING_LABELS_REQUEST = "UPDATE_ADMIN_BOOKING_LABELS_REQUEST";
export const UPDATE_ADMIN_BOOKING_LABELS_SUCCESS = "UPDATE_ADMIN_BOOKING_LABELS_SUCCESS";
export const UPDATE_ADMIN_BOOKING_LABELS_FAILURE = "UPDATE_ADMIN_BOOKING_LABELS_FAILURE";

export const UPDATE_ADMIN_BOOKING_TENANT_FEATURES_REQUEST = "UPDATE_ADMIN_BOOKING_TENANT_FEATURES_REQUEST";
export const UPDATE_ADMIN_BOOKING_TENANT_FEATURES_SUCCESS = "UPDATE_ADMIN_BOOKING_TENANT_FEATURES_SUCCESS";
export const UPDATE_ADMIN_BOOKING_TENANT_FEATURES_FAILURE = "UPDATE_ADMIN_BOOKING_TENANT_FEATURES_FAILURE";

export const FETCH_ADMIN_BOOKING_VERSION_FEATURES_REQUEST = "FETCH_ADMIN_BOOKING_VERSION_FEATURES_REQUEST";
export const FETCH_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS = "FETCH_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS";
export const FETCH_ADMIN_BOOKING_VERSION_FEATURES_FAILURE = "FETCH_ADMIN_BOOKING_VERSION_FEATURES_FAILURE";

export const UPDATE_ADMIN_BOOKING_VERSION_FEATURES_REQUEST = "UPDATE_ADMIN_BOOKING_VERSION_FEATURES_REQUEST";
export const UPDATE_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS = "UPDATE_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS";
export const UPDATE_ADMIN_BOOKING_VERSION_FEATURES_FAILURE = "UPDATE_ADMIN_BOOKING_VERSION_FEATURES_FAILURE";

export const DELETE_ADMIN_BOOKING_VERSION_FEATURES_REQUEST = "DELETE_ADMIN_BOOKING_VERSION_FEATURES_REQUEST";
export const DELETE_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS = "DELETE_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS";
export const DELETE_ADMIN_BOOKING_VERSION_FEATURES_FAILURE = "DELETE_ADMIN_BOOKING_VERSION_FEATURES_FAILURE";

export const UPDATE_ADMIN_FAULT_STATUS_REQUEST = "UPDATE_ADMIN_FAULT_STATUS_REQUEST";
export const UPDATE_ADMIN_FAULT_STATUS_SUCCESS = "UPDATE_ADMIN_FAULT_STATUS_SUCCESS";
export const UPDATE_ADMIN_FAULT_STATUS_FAILURE = "UPDATE_ADMIN_FAULT_STATUS_FAILURE";

export const CLEAR_ADMIN_SHARED_TENANT_MUTATION_ERRORS = "CLEAR_ADMIN_SHARED_TENANT_MUTATION_ERRORS";

export const UPDATE_ADMIN_SHARED_TENANT_EDIT_REQUEST = "UPDATE_ADMIN_SHARED_TENANT_EDIT_REQUEST";
export const UPDATE_ADMIN_SHARED_TENANT_EDIT_SUCCESS = "UPDATE_ADMIN_SHARED_TENANT_EDIT_SUCCESS";
export const UPDATE_ADMIN_SHARED_TENANT_EDIT_FAILURE = "UPDATE_ADMIN_SHARED_TENANT_EDIT_FAILURE";

export const ONBOARD_ADMIN_SHARED_TENANT_REQUEST = "ONBOARD_ADMIN_SHARED_TENANT_REQUEST";
export const ONBOARD_ADMIN_SHARED_TENANT_SUCCESS = "ONBOARD_ADMIN_SHARED_TENANT_SUCCESS";
export const ONBOARD_ADMIN_SHARED_TENANT_FAILURE = "ONBOARD_ADMIN_SHARED_TENANT_FAILURE";

export const RESET_ADMIN_SHARED_TENANT_PASSWORDS_REQUEST = "RESET_ADMIN_SHARED_TENANT_PASSWORDS_REQUEST";
export const RESET_ADMIN_SHARED_TENANT_PASSWORDS_SUCCESS = "RESET_ADMIN_SHARED_TENANT_PASSWORDS_SUCCESS";
export const RESET_ADMIN_SHARED_TENANT_PASSWORDS_FAILURE = "RESET_ADMIN_SHARED_TENANT_PASSWORDS_FAILURE";

export const RUN_ADMIN_SHARED_TENANT_CLEANUP_REQUEST = "RUN_ADMIN_SHARED_TENANT_CLEANUP_REQUEST";
export const RUN_ADMIN_SHARED_TENANT_CLEANUP_SUCCESS = "RUN_ADMIN_SHARED_TENANT_CLEANUP_SUCCESS";
export const RUN_ADMIN_SHARED_TENANT_CLEANUP_FAILURE = "RUN_ADMIN_SHARED_TENANT_CLEANUP_FAILURE";

export const DELETE_ADMIN_SHARED_TENANT_REQUEST = "DELETE_ADMIN_SHARED_TENANT_REQUEST";
export const DELETE_ADMIN_SHARED_TENANT_SUCCESS = "DELETE_ADMIN_SHARED_TENANT_SUCCESS";
export const DELETE_ADMIN_SHARED_TENANT_FAILURE = "DELETE_ADMIN_SHARED_TENANT_FAILURE";

export const RELEASE_ADMIN_SHARED_TENANT_REQUEST = "RELEASE_ADMIN_SHARED_TENANT_REQUEST";
export const RELEASE_ADMIN_SHARED_TENANT_SUCCESS = "RELEASE_ADMIN_SHARED_TENANT_SUCCESS";
export const RELEASE_ADMIN_SHARED_TENANT_FAILURE = "RELEASE_ADMIN_SHARED_TENANT_FAILURE";

// Email migration
export const REQUEST_EMAIL_CHANGE_REQUEST = "REQUEST_EMAIL_CHANGE_REQUEST";
export const REQUEST_EMAIL_CHANGE_SUCCESS = "REQUEST_EMAIL_CHANGE_SUCCESS";
export const REQUEST_EMAIL_CHANGE_FAILURE = "REQUEST_EMAIL_CHANGE_FAILURE";

export const VERIFY_EMAIL_CHANGE_REQUEST = "VERIFY_EMAIL_CHANGE_REQUEST";
export const VERIFY_EMAIL_CHANGE_SUCCESS = "VERIFY_EMAIL_CHANGE_SUCCESS";
export const VERIFY_EMAIL_CHANGE_FAILURE = "VERIFY_EMAIL_CHANGE_FAILURE";

export const RESEND_EMAIL_CHANGE_REQUEST = "RESEND_EMAIL_CHANGE_REQUEST";
export const RESEND_EMAIL_CHANGE_SUCCESS = "RESEND_EMAIL_CHANGE_SUCCESS";
export const RESEND_EMAIL_CHANGE_FAILURE = "RESEND_EMAIL_CHANGE_FAILURE";

export const CHECK_EMAIL_MIGRATION_STATUS_REQUEST = "CHECK_EMAIL_MIGRATION_STATUS_REQUEST";
export const CHECK_EMAIL_MIGRATION_STATUS_SUCCESS = "CHECK_EMAIL_MIGRATION_STATUS_SUCCESS";
export const CHECK_EMAIL_MIGRATION_STATUS_FAILURE = "CHECK_EMAIL_MIGRATION_STATUS_FAILURE";

export const RESET_EMAIL_MIGRATION_STATE = "RESET_EMAIL_MIGRATION_STATE";

// Admin Alerts
export const FETCH_ADMIN_ALERT_REQUEST = "FETCH_ADMIN_ALERT_REQUEST";
export const FETCH_ADMIN_ALERT_SUCCESS = "FETCH_ADMIN_ALERT_SUCCESS";
export const FETCH_ADMIN_ALERT_FAILURE = "FETCH_ADMIN_ALERT_FAILURE";

export const SAVE_ADMIN_ALERT_REQUEST = "SAVE_ADMIN_ALERT_REQUEST";
export const SAVE_ADMIN_ALERT_SUCCESS = "SAVE_ADMIN_ALERT_SUCCESS";
export const SAVE_ADMIN_ALERT_FAILURE = "SAVE_ADMIN_ALERT_FAILURE";

export const DELETE_ADMIN_ALERT_REQUEST = "DELETE_ADMIN_ALERT_REQUEST";
export const DELETE_ADMIN_ALERT_SUCCESS = "DELETE_ADMIN_ALERT_SUCCESS";
export const DELETE_ADMIN_ALERT_FAILURE = "DELETE_ADMIN_ALERT_FAILURE";
